var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { getCollectionsUrl } from "./platform";
import { getDraftByHRN, getIndoorSiteInSnapshot, getDrafts } from "./venues";
import IndoorHelper from "../store/helpers/indoorHelper";
import { ORG_TENANT } from "./constant";
import { setCollectionLoaded, setCollectionMetaList, setMapOrdersMetaList, } from "../store/reducers/appSlice";
import { PROMISE_RESPOSE, DRAFT_TYPE, MAP_STATUS, } from "../store/common/constants";
import indoorHelper from "../store/helpers/indoorHelper";
/**
 * method to get collection meta using collection hrn
 * @param token {string} - authorization token
 * @param collectionHrn {string} - id for getting collection meta
 * @returns - response data or error status
 */
export var getCollectionsMeta = function (token, collectionHrn) { return __awaiter(void 0, void 0, void 0, function () {
    var collectionsMetaUrl;
    var _a;
    return __generator(this, function (_b) {
        try {
            collectionsMetaUrl = getCollectionsUrl();
            collectionsMetaUrl = collectionsMetaUrl + "/" + collectionHrn;
            return [2 /*return*/, axios.get(collectionsMetaUrl, {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                    },
                })];
        }
        catch (err) {
            return [2 /*return*/, Promise.reject((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data.status)];
        }
        return [2 /*return*/];
    });
}); };
/**
 * method to get snapshot using the collectionHRN
 * @param token {string} - authorization token
 * @param collectionHRN {string} - the snapshot to get from particular collection
 * @returns - response data or error status
 */
export var getSnapshots = function (token, collectionHRN) { return __awaiter(void 0, void 0, void 0, function () {
    var collectionsUrl, snapshotUrl;
    return __generator(this, function (_a) {
        try {
            collectionsUrl = getCollectionsUrl();
            snapshotUrl = collectionsUrl + "/" + collectionHRN + "/snapshots";
            return [2 /*return*/, axios.get(snapshotUrl, {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                    },
                })];
        }
        catch (err) {
            return [2 /*return*/, Promise.reject(err)];
        }
        return [2 /*return*/];
    });
}); };
export var getCollectionMeta = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var collectionMetaAsync, snapshotAsync, qaReportAsync, collectionTabList, token, defaultSnapshotTime, listCollectionMeta, snapShotTime, _i, collectionTabList_1, file, collectionMetaAsyncResp, snapShotResp, qaReportResponse, i, collectionMeta, indoorSiteInSnapshot, mapsInCollection, today, snapShotDate;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                collectionMetaAsync = {};
                snapshotAsync = {};
                qaReportAsync = {};
                collectionTabList = getState().overview.collectionTabList;
                token = getState().user.token;
                defaultSnapshotTime = getState().overview.defaultSnapshotTime;
                listCollectionMeta = [];
                for (_i = 0, collectionTabList_1 = collectionTabList; _i < collectionTabList_1.length; _i++) {
                    file = collectionTabList_1[_i];
                    collectionMetaAsync[file] = getCollectionsMeta(token, file);
                    snapshotAsync[file] = getSnapshots(token, file);
                }
                return [4 /*yield*/, Promise.all(Object.values(collectionMetaAsync))];
            case 1:
                collectionMetaAsyncResp = (_g.sent());
                return [4 /*yield*/, Promise.all(Object.values(snapshotAsync))];
            case 2:
                snapShotResp = (_g.sent());
                return [4 /*yield*/, Promise.allSettled(Object.values(qaReportAsync))];
            case 3:
                qaReportResponse = _g.sent();
                i = 0;
                _g.label = 4;
            case 4:
                if (!(i < collectionTabList.length)) return [3 /*break*/, 8];
                collectionMeta = __assign(__assign({}, (_a = collectionMetaAsyncResp === null || collectionMetaAsyncResp === void 0 ? void 0 : collectionMetaAsyncResp[i]) === null || _a === void 0 ? void 0 : _a.data), { snapShotDate: "N/A", hrn: collectionTabList[i], mapsInCollection: [] });
                if (!(((_d = (_c = (_b = snapShotResp[i]) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.snapshotTimes) === null || _d === void 0 ? void 0 : _d.length) !== 0)) return [3 /*break*/, 6];
                snapShotTime = new Date((_e = snapShotResp[i]) === null || _e === void 0 ? void 0 : _e.data.snapshotTimes[0]);
                return [4 /*yield*/, getIndoorSiteInSnapshot(token, collectionTabList[i], snapShotTime.getTime())];
            case 5:
                indoorSiteInSnapshot = _g.sent();
                mapsInCollection = indoorSiteInSnapshot.features.map(function (map) {
                    var _a, _b;
                    return {
                        mapid: map.properties.indoorMapId,
                        mapcity: (_a = map.properties.address.city.names[0]) === null || _a === void 0 ? void 0 : _a.name,
                        mapName: (_b = map.properties.placeProperties.names[0]) === null || _b === void 0 ? void 0 : _b.name,
                    };
                });
                today = new Date();
                snapShotDate = void 0;
                snapShotTime > today
                    ? (snapShotDate = "N/A")
                    : (snapShotDate =
                        IndoorHelper.formatDateWithYearMonthDayFormat(snapShotTime));
                if (collectionMeta.maps.length === 0) {
                    collectionMeta.maps = mapsInCollection;
                }
                collectionMeta.snapShotDate = snapShotDate;
                collectionMeta.mapsInCollection = mapsInCollection;
                _g.label = 6;
            case 6:
                // default catalog will have snapshotDate "N/A", hence take that from store or else take latest snapshot for each collection for open it in imc further
                collectionMeta.latestSnapshot =
                    collectionMeta.snapShotDate === "N/A"
                        ? defaultSnapshotTime
                        : snapShotTime.getTime();
                collectionMeta.qaReportExists =
                    ((_f = qaReportResponse === null || qaReportResponse === void 0 ? void 0 : qaReportResponse[i]) === null || _f === void 0 ? void 0 : _f.status) === PROMISE_RESPOSE.FULFILLED;
                listCollectionMeta.push(collectionMeta);
                _g.label = 7;
            case 7:
                i++;
                return [3 /*break*/, 4];
            case 8:
                dispatch(setCollectionMetaList(listCollectionMeta));
                dispatch(setCollectionLoaded(true));
                return [2 /*return*/];
        }
    });
}); }; };
/**
 * method to get shared drafts details for displaying on map orders tab
 * @returns - response data or error status
 */
export var getMapOrderDetails = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, _a, draftHrns, userInfo, allowedDraftTypes, detailsObj, _i, draftHrns_1, draft, draftsDetailsAsyncResp, mapOrderResMeta, mapOrderRes, mapOrderResMetaList, i, hrn, org, e_1;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return __generator(this, function (_l) {
        switch (_l.label) {
            case 0:
                dispatch(setMapOrdersMetaList({
                    isLoading: true,
                    mapOrderList: [],
                }));
                token = getState().user.token;
                _l.label = 1;
            case 1:
                _l.trys.push([1, 4, , 5]);
                return [4 /*yield*/, getDrafts(token)];
            case 2:
                _a = (_l.sent()).draftHrns, draftHrns = _a === void 0 ? [] : _a;
                userInfo = getState().user.info;
                allowedDraftTypes = [DRAFT_TYPE.NEW_ORDER, DRAFT_TYPE.UPDATE_ORDER];
                detailsObj = {};
                for (_i = 0, draftHrns_1 = draftHrns; _i < draftHrns_1.length; _i++) {
                    draft = draftHrns_1[_i];
                    detailsObj[draft] = getDraftByHRN(token, draft);
                }
                return [4 /*yield*/, Promise.all(Object.values(detailsObj))];
            case 3:
                draftsDetailsAsyncResp = (_l.sent());
                mapOrderResMeta = {};
                mapOrderRes = [];
                mapOrderRes = __spreadArray([], draftsDetailsAsyncResp, true);
                mapOrderResMetaList = [];
                //tab will display only new Order maps which haven't been checkedIn
                for (i = 0; i < draftHrns.length; i++) {
                    if (allowedDraftTypes.includes((_b = mapOrderRes === null || mapOrderRes === void 0 ? void 0 : mapOrderRes[i]) === null || _b === void 0 ? void 0 : _b.draftType) &&
                        ((_c = mapOrderRes === null || mapOrderRes === void 0 ? void 0 : mapOrderRes[i]) === null || _c === void 0 ? void 0 : _c.draftState) !== MAP_STATUS.CHECKED_IN.VALUE) {
                        hrn = draftHrns[i];
                        org = userInfo.realm === indoorHelper.getRealmFromHrn(hrn)
                            ? ORG_TENANT.INTERNAL
                            : ORG_TENANT.EXTERNAL;
                        mapOrderResMeta = {
                            mapId: indoorHelper.getMapUUId(draftHrns[i]).replace("-draft", ""),
                            mapName: (_e = (_d = mapOrderRes === null || mapOrderRes === void 0 ? void 0 : mapOrderRes[i]) === null || _d === void 0 ? void 0 : _d.orderData) === null || _e === void 0 ? void 0 : _e.mapName,
                            organizationId: (_h = (_g = (_f = mapOrderRes === null || mapOrderRes === void 0 ? void 0 : mapOrderRes[i]) === null || _f === void 0 ? void 0 : _f.orderData) === null || _g === void 0 ? void 0 : _g.requesterInformation) === null || _h === void 0 ? void 0 : _h.organizationId,
                            supportTicketNumber: (_k = (_j = mapOrderRes === null || mapOrderRes === void 0 ? void 0 : mapOrderRes[i]) === null || _j === void 0 ? void 0 : _j.orderData) === null || _k === void 0 ? void 0 : _k.supportTicketNumber,
                            hrn: hrn,
                            org: org,
                            isCheckInDisabled: userInfo.realm !== indoorHelper.getRealmFromHrn(hrn),
                        };
                        mapOrderResMetaList.push(mapOrderResMeta);
                    }
                }
                dispatch(setMapOrdersMetaList({
                    isLoading: false,
                    mapOrderList: mapOrderResMetaList,
                }));
                return [3 /*break*/, 5];
            case 4:
                e_1 = _l.sent();
                dispatch(setMapOrdersMetaList({
                    isLoading: false,
                    mapOrderList: [],
                }));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
